<template>
  <a-card :bordered="false">
    <div slot="title" style="border-left: 1px solid #FAAD14;padding-left: 10px">打卡任务</div>
    <a-form-model
      style="width: 800px;"
      :label-col="{span:4}"
      :wrapper-col="{span:20}"
      ref="form"
      :model="attendanceForm"
      :rules="attendanceRules"
    >
      <a-form-model-item
        label="是否开启打卡任务"
        style="width: 100%"
        prop="clockStatus">
        <a-switch
          checked-children="开"
          un-checked-children="关"
          v-model="attendanceForm.clockStatus"></a-switch>
        <div style="width: calc(100% - 100px);display: inline-block;">
          <a-tooltip
            style="margin-left: 10px"
            placement="top"
            title="如果关闭后再次开启打卡任务，分销员签到天数重新开始"
            :get-popup-container="getPopupContainer"
            :defaultVisible="true"
          >
            <a-icon type="question-circle"/>
          </a-tooltip>
        </div>
      </a-form-model-item>

      <a-form-model-item
        label="签到提醒时间"
        prop="clockRemindTime">

        <a-select v-model="attendanceForm.clockRemindTime" placeholder="请选择" style="width: 130px">
          <a-select-option v-for="item in 24" :key="setHour(item-1)">
            {{ setHour(item - 1) }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="每日签到时间"
      >
        <a-form-model-item
          style="display: inline-block;margin-bottom: 0"
          prop="clockStartTime">
          <a-time-picker
            v-model="attendanceForm.clockStartTime"
            :allowClear="false"
            format="HH:mm"
            placeholder="请选择"
          />
        </a-form-model-item>
        到
        <a-form-model-item
          style="display: inline-block;margin-bottom: 0"
          prop="clockEndTime">
          <a-time-picker
            v-model="attendanceForm.clockEndTime"
            :allowClear="false"
            format="HH:mm"
            placeholder="请选择"
          />
        </a-form-model-item>
      </a-form-model-item>
      <a-form-model-item
        label="每日签到领取"
        :required="true"
        prop="receiveByClockEveryday">
        <a-input
          v-model="attendanceForm.receiveByClockEveryday"
          style="width: 120px;"
          type="number"
          placeholder="请输入"
        ><span slot="addonAfter">元</span>
        </a-input>
      </a-form-model-item>
      <a-form-model-item
        label="连续签到第"
        v-for="(item,index) in attendanceForm.clockReceiveRules"
        :key="index"
      >
        <a-form-model-item
          style="margin-bottom: 0;display: inline-block"
          :prop="'clockReceiveRules.'+index+'.consecutiveDayNumber'"
          :rules="attendanceRules['clockReceiveRules.consecutiveDayNumber']"
        >
          <a-input
            v-model="item.consecutiveDayNumber"
            style="width: 140px"
            type="number"
            placeholder="请输入"
          ><span slot="addonAfter">天</span></a-input>
        </a-form-model-item>
        <a-form-model-item
          style="margin-bottom: 0;display: inline-block;margin-left: 20px"
          :prop="'clockReceiveRules.'+index+'.receiveAmount'"
          :rules="attendanceRules['clockReceiveRules.receiveAmount']"
        >
          领取
          <a-input
            v-model="item.receiveAmount"
            style="width: 140px;"
            placeholder="请输入"
            type="number"
          ><span slot="addonAfter">元</span></a-input>
          <a-button v-if="index===0" @click="addOptionEvent" style="margin-left: 20px" type="primary">添加</a-button>
          <a-button
            v-else
            style="margin-left: 20px"
            type="danger"
            @click="()=>deleteOptionEvent(index)">删除
          </a-button>
        </a-form-model-item>
      </a-form-model-item>
      <a-form-model-item
        label="指定分组参与"
      >
        <a-tag
          v-for="(item ,index) in attendanceForm.appointGroups"
          :key="index"
          :style="{'margin-left': index===0?0:10+'px'}"
          :closable="true" @close="() => handleCloseTasEvent(item,index,1)"
        >分组ID：{{ item.groupId }}
        </a-tag>
        <a-button type="primary" style="margin-left: 20px" @click="addTasEvent(1)">添加</a-button>
      </a-form-model-item>
      <a-form-model-item
        label="黑名单分组"
      >
        <a-tag
          v-for="(item ,index2) in attendanceForm.blackGroups"
          :key="index2"
          :style="{'margin-left': index2===0?0:10+'px'}"
          :closable="true" @close="() => handleCloseTasEvent(item,index2,2)"
        >分组ID：{{ item.groupId }}
        </a-tag>
        <a-button type="primary" style="margin-left: 20px" @click="addTasEvent(2)">添加</a-button>
      </a-form-model-item>
      <a-form-model-item
        label="任务说明"
        :required="true"
        prop="clockExplain">
        <a-textarea
          v-model="attendanceForm.clockExplain"
          :rows="4"
          placeholder="请输入"
          :max-length="200"
        ></a-textarea>
      </a-form-model-item>
      <a-form-model-item
        label="  "
        :colon="false"
        :required="false"
      >
        <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存</a-button>
      </a-form-model-item>
    </a-form-model>


    <a-modal
      :title="tasTitle"
      :visible="tasVisible"
      @cancel="tasVisible = false"
      :footer="null"
      width="800px"
    >
      <search-page-view
        :col="3"
        ref="pageList"
        :itemNames="['s1','s2']"
        :columns="getColumns()"
        :show-reset-button="true"
        :queryParams="queryParams"
        row-key="groupId"
        :leftSpace="10"
        :requestPromise="getTaskList"
        @reset="onRestEvent"
      >
        <a-form-item slot="s1" label="分组ID" v-bind="searchItemLayout">
          <a-input v-model="queryParams.groupId " placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item slot="s2" label="分组名称" v-bind="searchItemLayout">
          <a-input v-model="queryParams.groupName" placeholder="请输入"></a-input>
        </a-form-item>
        <template slot="action" slot-scope="data">
          <a @click="chooseInfo(data.record)">选择</a>
        </template>
      </search-page-view>
    </a-modal>
  </a-card>
</template>

<script>
//每日签到（打卡任务）
import salesTaskMixins from '@/views/service/serviceProvider/salesTask/salesTaskMixins'

export default {
  name: 'DailyAttendance',
  mixins: [salesTaskMixins],
  data() {
    return {
      saveLoading: false,
      attendanceForm: {
        clockStatus: false,
        receiveByClockEveryday: undefined,
        clockRemindTime: undefined,
        clockStartTime: undefined,
        clockEndTime: undefined,
        clockReceiveRules: [{}],
        blackGroups: [],
        appointGroups: [],
        clockExplain: ''
      },
      attendanceRules: {
        clockStatus: [
          { required: false, message: 'tips', trigger: ['blur', 'change'] }
        ],
        clockRemindTime: [
          { required: true, message: '请选择提醒时间', trigger: ['blur', 'change'] }
          /*, { validator: this.validatorRemindTime, trigger: ['blur', 'change'] }*/
        ],
        clockStartTime: [
          { required: true, message: '请选择开始时间', trigger: ['blur', 'change'] }
        ],
        clockEndTime: [
          { required: true, message: '请选择结束时间', trigger: ['blur', 'change'] }
        ],
        receiveByClockEveryday: [
          { required: true, message: '请输入金额', trigger: ['blur', 'change'] },
          {
            pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/,
            message: '请输入正确的金额',
            trigger: ['blur', 'change']
          }
        ],
        'clockReceiveRules.consecutiveDayNumber': [
          { required: false, message: '请输入天数', trigger: ['blur', 'change'] }
          , { validator: this.validatorOptionsDay, trigger: ['blur', 'change'] }
        ],
        'clockReceiveRules.receiveAmount': [
          { required: false, message: '请输入金额', trigger: ['blur', 'change'] }
          , { validator: this.validatorOptionsMoney, trigger: ['blur', 'change'] }
        ],
        clockExplain: [
          { required: true, message: '请输入任务说明', trigger: ['blur', 'change'] }
        ]
      },
      tasVisible: false,
      queryParams: {},
      tasNum: 1,
      tasTitle: ''
    }
  },
  created() {
    this.getClockDetail()
  },
  mounted() {
  },
  methods: {
    setHour(item) {
      let hour = (item < 10 ? '0' + item.toFixed(0) : item.toFixed(0)) + ':00'
      return hour
    },
    getClockDetail() {
      this.getHttpServices().getUserService().post('merchant/v2/clock/getClockDetail')
        .then(res => {
          let info = res
          info.clockStatus = info.clockStatus == 1 ? true : false
          // info.clockRemindTime = this.getDateHelper().getTimeMinute(info.clockRemindTime)
          info.clockStartTime = this.getDateHelper().getTimeMinute(info.clockStartTime)
          info.clockEndTime = this.getDateHelper().getTimeMinute(info.clockEndTime)
          if (!info.clockReceiveRules.length) {
            info.clockReceiveRules = [
              {
                consecutiveDayNumber: '',
                receiveAmount: ''
              }
            ]
          }
          this.attendanceForm = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    validatorRemindTime(rule, value, callback) {
    },
    /**
     * 校验连续天数
     * */
    validatorOptionsDay(rule, value, callback) {
      if (value) {
        if (value <= 1) {
          callback(new Error('天数必须大于1'))
        } else if (!/^[0-9]\d{0,5}$/.test(value)) {
          callback(new Error('天数为整数'))
        } else if (this.attendanceForm.clockReceiveRules.length > 1) {
          let splits = rule.fullField.split('.')
          let index = splits[1]
          if (index > 0) {
            const validatorList = this.attendanceForm.clockReceiveRules.slice(0, index)
            if (validatorList.every(item => value > Number.parseInt(item.consecutiveDayNumber))) {
              callback()
            } else {
              callback(new Error('必须大于前面的天数'))
            }
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validatorOptionsMoney(rule, value, callback) { //金额校验
      if (value) {
        if (value < 0) {
          callback(new Error('金额需大于0'))
        } else if (!/^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/.test(value)) {
          callback(new Error('金额格式不正确'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    addOptionEvent() {
      this.attendanceForm.clockReceiveRules.push({})
    },
    deleteOptionEvent(index) {
      this.attendanceForm.clockReceiveRules = this.attendanceForm.clockReceiveRules.filter((item, oIndex) => index !== oIndex)
    },
    addTasEvent(num) {
      this.tasTitle = num == 1 ? '指定分组选择' : '黑名单分组选择'
      this.tasNum = num
      this.restQueryParams()
      this.tasVisible = true
      this.$nextTick(() => {
        this.$refs.pageList.refresh(true)
      })
    },
    chooseInfo(record) { //选择分组
      let list = this.tasNum === 1 ? [...this.attendanceForm.appointGroups] : [...this.attendanceForm.blackGroups]
      let arr = [{
        groupId: record.groupId,
        groupName: record.groupName
      }]
      if (list.length > 0) {
        let list2 = this.tasNum === 1 ? [...this.attendanceForm.blackGroups] : [...this.attendanceForm.appointGroups]
        let isRestId = list.find(item => item.groupId === record.groupId)
        let isRestId2 = list2.find(item => item.groupId === record.groupId)
        if (isRestId || isRestId2) {
          return this.$message.error('选择的分组已存在或指定分组与黑名单不能同时关联同一个分组')
        } else {
          if (this.tasNum === 1) {
            this.attendanceForm.appointGroups = this.attendanceForm.appointGroups.concat(arr)
          } else {
            this.attendanceForm.blackGroups = this.attendanceForm.blackGroups.concat(arr)
          }
        }
      } else {
        if (this.tasNum === 1) {
          this.attendanceForm.appointGroups = arr
        } else {
          this.attendanceForm.blackGroups = arr
        }
      }
      this.tasVisible = false
      this.getLogUtils().logWithTag('this.attendanceForm.appointGroups', this.attendanceForm.appointGroups)
    },
    /**
     * 标签关闭
     * @param item
     * @param index
     * @param type 1表示参与成员分组 2表示黑名单分组
     */
    handleCloseTasEvent(item, index, type) {
      let list = type === 1 ? [...this.attendanceForm.appointGroups] : [...this.attendanceForm.blackGroups]
      if (list.length > 0) {
        list = list.filter((item, fIndex) => fIndex !== index)
      }
      if (type === 1) {
        this.attendanceForm.appointGroups = list
      } else {
        this.attendanceForm.blackGroups = list
      }
    },
    saveEvent() {
      this.getLogUtils().logWithTag('==this.attendanceForm==', this.attendanceForm)
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.$message.error('请完善表单信息')
        }
      })
    },
    submitData() {
      let parms = JSON.parse(JSON.stringify(this.attendanceForm))
      let clockReceiveRules = parms.clockReceiveRules.find(item => item.consecutiveDayNumber && item.receiveAmount)
      if (!clockReceiveRules) {
        parms.clockReceiveRules = []
      }
      parms.clockStatus = parms.clockStatus ? 1 : 2
      // parms.clockRemindTime = this.getDateHelper().getTimeHourMinte(parms.clockRemindTime)
      parms.clockEndTime = this.getDateHelper().getTimeHourMinte(parms.clockEndTime)
      parms.clockStartTime = this.getDateHelper().getTimeHourMinte(parms.clockStartTime)
      this.submitLoading = true
      this.getHttpServices().getUserService().post('merchant/v2/clock/setClock', parms)
        .then(res => {
          this.$message.success('任务设置成功')
          setTimeout(() => this.backEvent(), 500)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    getColumns() {
      return [
        {
          title: '分组ID',
          dataIndex: 'groupId'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '成员数',
          dataIndex: 'staffNumber'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getTaskList(params) {
      return this.getHttpServices().getUserService().post('merchant/v2/clock/getSettingGroups', params)
    },
    onRestEvent() {
      this.restQueryParams()
    },
    restQueryParams() {
      this.queryParams = {
        groupTaskType: 2,
        settingId: this.attendanceForm.id ? this.attendanceForm.id : 0
      }
    }

  }

}
</script>
<style scoped>
</style>